import { CODE_SYSTEMS } from '@liza/fhir-utils';
import type { ValueSet } from '@medplum/fhirtypes';

const URL = 'https://liza.health/fhir/ValueSet/primary-care-medication-routes';

export const lizaPrimaryCareMedicationRoutes = {
  resourceType: 'ValueSet',
  name: 'liza-primary-care-medication-routes',
  title: 'Liza Primary Care Medication Routes',
  url: URL,
  identifier: [{ system: 'urn:ietf:rfc:3986', value: URL }],
  version: '1',
  status: 'active',
  description:
    'Curated subset of http://hl7.org/fhir/ValueSet/route-codes for medication administration routes commonly used in Liza primary care workflows.',
  compose: {
    include: [
      {
        system: CODE_SYSTEMS.SNOMED,
        concept: [
          { code: '10547007', display: 'Otic route' },
          { code: '16857009', display: 'Per vagina' },
          { code: '26643006', display: 'Oral route' },
          { code: '34206005', display: 'Subcutaneous route' },
          { code: '37161004', display: 'Per rectum' },
          { code: '37839007', display: 'Sublingual route' },
          { code: '45890007', display: 'Transdermal route' },
          { code: '46713006', display: 'Nasal route' },
          { code: '47625008', display: 'Intravenous route' },
          { code: '54471007', display: 'Buccal route' },
          { code: '54485002', display: 'Ophthalmic route' },
          { code: '6064005', display: 'Topical route' },
          { code: '78421000', display: 'Intramuscular route' },
        ],
      },
    ],
  },
} as const satisfies ValueSet;
